// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"64aababc","455":"9bcea31d","977":"00b284dc"}[chunkId] + ".chunk.js";
};